module.exports = __webpack_public_path__ + "static/media/footer-bnr_368x70.c4a03584.gif";